import React, { useState, useEffect } from "react";
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import Paginat from "@/components/lib/paginat";
import AllOrderStatusTable from "@/components/online-ordering/websiteOrdering/AllOrderStatusTable";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import AllOrderRequestTable from "@/components/online-ordering/websiteOrdering/AllOrderRequestTable";
import { Separator } from "@/components/ui/separator";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderWiseStatus } from "@/redux/slice/order-ordering-slice/order-status-slice";
import useDebounce from "@/hooks/useDebounce";
import useAuth from "@/hooks/useAuth";

const OrderStatus = () => {
  const dispatch = useDispatch();
  const { pagination, getLoading, orders } = useSelector(
    (state) => state.onlineOrdering.orderStatus,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [orderType, setOrderType] = useState("");
  const [perPage, setPerPage] = useState("10");
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("in_progress");
  const [sortField, setSortField] = useState("unique_id");
  const [sortOrder, setSortOrder] = useState("desc");
  const debouncedSearchTerm = useDebounce(query);
  const { user } = useAuth();

  const tabValueFromStatus = (s) => {
    if (!s) return "in-progress";
    if (s === "in_progress") return "in-progress";
    if (s === "completed") return "completed";
    if (s === "cancelled") return "cancelled";
    return "in-progress";
  };

  const tabValue = tabValueFromStatus(status);

  useEffect(() => {
    const apiStatus =
      status === "in_progress"
        ? "accepted"
        : status === "completed"
          ? "accepted"
          : "cancelled";
    const apiStage =
      status === "in_progress"
        ? "on_going"
        : status === "completed"
          ? "completed"
          : "cancelled";

    dispatch(
      fetchOrderWiseStatus({
        restaurant_id: user.restaurant_id,
        // source: "website",
        order_type: orderType,
        status: apiStatus,
        stage: apiStage,
        sort_field: sortField,
        sort_order: sortOrder,
        page: currentPage,
        per_page: Number(perPage),
        search_term: debouncedSearchTerm,
      }),
    );
  }, [
    dispatch,
    currentPage,
    perPage,
    debouncedSearchTerm,
    user.restaurant_id,
    orderType,
    status,
    sortField,
    sortOrder,
  ]);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
      pageName={{ title: "Order Request" }}
      paths={[
        // { name: "Home", path: "/home" },
        // { name: "Online Ordering", path: "/online-ordering" },
        {
          name: "Website Ordering",
          path: "/onlineordering/website-ordering/order-request",
        },
        { name: "Order Status" },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <Tabs
          value={tabValue}
          onValueChange={(value) => {
            const mapping = {
              "in-progress": "in_progress",
              completed: "completed",
              cancelled: "cancelled",
            };
            setStatus(mapping[value] || "in_progress");
            setCurrentPage(1);
          }}
          className="bg-transparent relative"
        >
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="in-progress">
              In-Progress
            </TabsTrigger>
            <TabsTrigger value="completed">Completed</TabsTrigger>
            <TabsTrigger value="cancelled">Cancelled</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          {/* <DrinkListTabs />
          <DraftList /> */}
        </Tabs>
        <Card className="bg-cblack3 border-0">
          <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
            <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
              <div className="flex justify-between items-center gap-3">
                <div className="grid w-full min-w-[250px] items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Order ID/Name/Phone
                  </Label>
                  <Input
                    className="text-gray-300"
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="search by  Order ID/Name/Phone"
                  />
                </div>
                <div className="grid w-full max-w-sm items-center gap-1.5">
                  <Label className="text-base text-white" htmlFor="">
                    Order Type
                  </Label>
                  <Select value={orderType} onValueChange={setOrderType}>
                    <SelectTrigger className="w-[200px]">
                      <SelectValue placeholder="Filter by type" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Order Type</SelectLabel>
                        <SelectItem value={null}>All</SelectItem>
                        <SelectItem value="delivery">Delivery</SelectItem>
                        <SelectItem value="pick_up">Pick up </SelectItem>
                        <SelectItem value="reservation">Reservation</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <h3 className="text-white">Show</h3>
                <Select value={perPage} onValueChange={setPerPage}>
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="50">50</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <div className="w-full">
              {getLoading ? (
                <OnlyTableSekeleton header={false} row={3} />
              ) : (
                <AllOrderRequestTable
                  setSortField={setSortField}
                  setSortOrder={setSortOrder}
                  sortOrder={sortOrder}
                  tableData={orders}
                />
              )}

              <Paginat
                className="mt-2"
                pagination={pagination}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout2>
  );
};

export default OrderStatus;
